import { AsyncStorage } from 'react-native';
import SimpleCrypto from 'simple-crypto-js';

let simpleCrypto = new SimpleCrypto('THIS IS SECRET');

export function encryptToken(token: string): string {
  return simpleCrypto.encrypt(token);
}
export function decryptToken(encryptToken: string): string {
  let decryptedToken = simpleCrypto.decrypt(encryptToken);
  return decryptedToken as string;
}

export let saveToken = (userToken: string) => {
  let encriptUserToken = encryptToken(userToken);
  AsyncStorage.setItem('token', encriptUserToken);
};

export let saveRole = (userRole: string) => {
  AsyncStorage.setItem('role', userRole);
};

export let getRole = () => {
  return AsyncStorage.getItem('role') || '';
};

export let getToken = async () => {
  let userToken = await AsyncStorage.getItem('token');
  return userToken ? decryptToken(userToken) : null;
};

export let removeToken = () => {
  return AsyncStorage.removeItem('token');
};

export let removeRole = () => {
  return AsyncStorage.removeItem('role');
};
